// TODO: after we get the confirmation that this implementation works well we can easily move it to the `services` repository to the `Base localization service`
const UNBREAKABLE_SPACE = "\u00A0";
const UNBREAKABLE_HYPHEN = "\u2011";
const HYPHEN = "-";
const SPACE = " ";

const unbreakableSingleSyllableWords = (s: string): string => s.replace(/ ([a-zA-Z]{1,2}) /g, " $1" + UNBREAKABLE_SPACE);

const unbreakableSpaces = (s: string): string => {
  const regExp = new RegExp(SPACE, "g");

  return s.replace(regExp, UNBREAKABLE_SPACE);
};

const unbreakableHyphenWords = (s: string): string => {
  const regExp = new RegExp(HYPHEN, "g");

  return s.replace(regExp, UNBREAKABLE_HYPHEN);
};

const breakableHyphenWords = (s: string): string => {
  const regExp = new RegExp(UNBREAKABLE_HYPHEN, "g");

  return s.replace(regExp, HYPHEN);
};

const formatTextWithUnbreakableRules = (s: string): string => unbreakableSingleSyllableWords(unbreakableHyphenWords(s));

const unbreakableDate = (s: string): string => unbreakableSpaces(unbreakableHyphenWords(s));

export {
  unbreakableHyphenWords,
  breakableHyphenWords,
  unbreakableSpaces,
  unbreakableDate,
  unbreakableSingleSyllableWords,
  formatTextWithUnbreakableRules,
};
